import { render, staticRenderFns } from "./employmentDetails.vue?vue&type=template&id=de6ecc50"
import script from "./employmentDetails.vue?vue&type=script&lang=js"
export * from "./employmentDetails.vue?vue&type=script&lang=js"
import style0 from "./employmentDetails.vue?vue&type=style&index=0&id=de6ecc50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports